import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, Dialog, DialogActions, DialogContent, IconButton, Tooltip, } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { FlagVariant } from "mdi-material-ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { trpcContext } from "../../lib/index.js";
export const ResignButton = ({ gid, room }) => {
    const { t } = useTranslation("ResignButton");
    const [confirm, setConfirm] = useState(false);
    const trpc = trpcContext.useTRPC();
    const { mutate: resign } = useMutation(trpc.resign.mutationOptions());
    return (_jsxs(_Fragment, { children: [_jsx(Tooltip, { title: t("resign").toString(), arrow: true, children: _jsx(Box, { sx: { display: "inline-flex" }, children: _jsx(IconButton, { onClick: () => setConfirm(true), children: _jsx(FlagVariant, {}) }) }) }), _jsxs(Dialog, { open: confirm, onClose: () => setConfirm(false), children: [_jsx(DialogContent, { children: t("confirmResign") }), _jsxs(DialogActions, { children: [_jsx(Button, { variant: "outlined", color: "inherit", onClick: () => setConfirm(false), children: t("cancel") }), _jsx(Button, { variant: "contained", onClick: () => {
                                    resign({ gid, room });
                                    setConfirm(false);
                                }, children: t("confirm") })] })] })] }));
};
//# sourceMappingURL=ResignButton.js.map